"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonText = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
/** A button which is styled like ordinary text, without a border or background */
exports.ButtonText = styled_components_1.styled.button `
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: ${({ theme }) => theme.fg};
  cursor: pointer;
  white-space: nowrap;
  justify-content: center;
`;
//# sourceMappingURL=ButtonText.js.map